<script setup lang="ts">
import { computed } from 'vue'
import { gradeBand } from '../palette'

/**
 * GradePill — a percentage in a band-coloured pill (mono digits). Colour
 * encodes the grade band; null renders a neutral em-dash.
 */
const props = withDefaults(defineProps<{ pct: number | null; size?: 'md' | 'lg' }>(), {
  size: 'md',
})
const band = computed(() => gradeBand(props.pct))
const display = computed(() => (props.pct == null ? null : Math.round(props.pct)))
</script>

<template>
  <span
    class="gradepill"
    :class="`gradepill--${size}`"
    :style="{ background: band.soft, color: band.ink }"
  >
    <template v-if="display == null">—</template>
    <template v-else>{{ display }}<span class="gradepill__pct">%</span></template>
  </span>
</template>

<style scoped>
.gradepill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: var(--radius-sm);
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  letter-spacing: -0.2px;
}
.gradepill--md {
  padding: 3px 8px;
  font-size: 12.5px;
}
.gradepill--lg {
  padding: 5px 10px;
  font-size: 14px;
}
.gradepill__pct {
  opacity: 0.55;
  font-weight: 500;
}
</style>
